import { FINALIZE_CHECKOUT_REQUEST, FINALIZE_CHECKOUT_SUCCESS, FINALIZE_CHECKOUT_ERROR, } from '../types';
import { forgetCart, loadCart } from '../cart';
/**
 * Forget the finalized order and load a new cart
 *
 * Before forgetting, it checks that the order that we are trying
 * to forget is the same as the one in the state. This check is useful
 * for example when people refresh the order confirmation page after
 * adding other products to the new cart in other browser tabs.
 */
const forgetFinalizedCart = (finalizedOrderNumber) => async (dispatch, getState) => {
    const { cart } = getState();
    if (cart.data?.number === finalizedOrderNumber) {
        await dispatch(forgetCart());
        dispatch(loadCart());
    }
};
export const finalizeCheckoutRequest = () => {
    return {
        type: FINALIZE_CHECKOUT_REQUEST,
    };
};
export const finalizeCheckoutSuccess = ({ cart, products, trackingIds, }) => {
    return {
        type: FINALIZE_CHECKOUT_SUCCESS,
        cart,
        products,
        trackingIds,
    };
};
export const finalizeCheckoutError = (error) => {
    return {
        type: FINALIZE_CHECKOUT_ERROR,
        error: true,
        payload: error,
    };
};
export const finalizeCheckout = (options) => {
    return async (dispatch, getState, { chord }) => {
        const { cart } = getState();
        const isStripe = !!options?.checkoutSessionId;
        dispatch(finalizeCheckoutRequest());
        try {
            dispatch(forgetFinalizedCart(options?.orderNumber));
            const finalizedOrder = isStripe
                ? await chord.oms.finalizeCheckout({
                    number: options?.orderNumber,
                    token: null,
                }, null, {
                    checkoutSessionId: options.checkoutSessionId,
                })
                : await chord.oms.finalizeCheckout({
                    number: cart.data.number,
                    token: cart.data.token,
                });
            dispatch(finalizeCheckoutSuccess({
                cart: finalizedOrder,
                products: options?.products,
                trackingIds: options?.trackingIds,
            }));
            return finalizedOrder;
        }
        catch (error) {
            dispatch(finalizeCheckoutError(error));
            throw error;
        }
    };
};
